module.exports = __webpack_public_path__ + "img/xianlin_techAct.d597005.png";